(function() {
  const dropdownTitle = document.querySelector('.product__dropdownMainTitle');
  const dropdownItems = document.querySelectorAll('.product__dropdownItem');
  const dropdownList = document.querySelector('.product__dropdownList');
  const tabTitles = document.querySelectorAll('.product__tabsTitle');
  const buttonsOverlay = document.querySelector('.product__buttons--overlay');
  const preorderMessage = document.querySelector('.product__preorderMessage');
  const pageWrapper = document.querySelector('.wrapper');
  // const buttonsOverlayItem = document.querySelector('.product__buttonsOverlay');
  let galleryHeight = document.querySelector('.product__gallery').scrollHeight;

  document.documentElement.style.setProperty('--gallery-height', `${galleryHeight}px`);

  function toggleDropdown(e) {
    dropdownList.classList.toggle('product__dropdownList--active');
  }

  function changeButtonData(target) {
    const buttonsWrapper = document.querySelector('.product__buttons');
    const addToCartButton = document.querySelector('.add-to-cart');

    addToCartButton.dataset.id = target.dataset.id;
    addToCartButton.dataset.inventoryQuantity = target.dataset.inventoryQuantity;

    if (target.dataset.inventoryQuantity <= 0) {
      addToCartButton.disabled = true;
      addToCartButton.classList.add('disabled');
      buttonsWrapper.classList.add('product__buttons--disabled');
      addToCartButton.querySelector('span').innerText = 'SOLD OUT';
      preorderMessage?.classList.remove('hidden');
    } else {
      addToCartButton.disabled = false;
      addToCartButton.classList.remove('disabled');
      buttonsWrapper.classList.remove('product__buttons--disabled');
      addToCartButton.querySelector('span').innerText = 'ADD TO BAG';
      preorderMessage?.classList.add('hidden');
    }
  }

  function toggleDropdownItem(target) {
    const activeItem = document.querySelector('.product__dropdownItem--active');
    const titleText = document.querySelector('.product__dropdownMainTitle p');
    const title = document.querySelector('.product__dropdownMainTitle');
    const currentTitle = target.querySelector('.product__dropdownTitle');
    const productHiddenSelect = document.querySelector('#product-select');

    if (target.matches('.product__dropdownItem--disabled')) {
      return false;
    }

    if (activeItem) {
      activeItem.classList.remove('product__dropdownItem--active');
    }

    target.classList.add('product__dropdownItem--active');
    titleText.innerText = `👉 ${currentTitle.innerText}`;
    title.dataset.size = target.dataset.size;

    if(productHiddenSelect) {
      productHiddenSelect.querySelectorAll('option').forEach(option => {
        if(option.value == target.dataset.id) {
          option.selected = true;
        }
      })
    }

    const url = new URL(window.location);
    url.searchParams.set('variant', target.dataset.id);
    window.history.pushState(null, '', url.toString());
    toggleDropdown();
    buttonsOverlay?.removeEventListener('click', openDropdown);
    // buttonsOverlayItem.classList.add('product__buttonsOverlay--hidden');
    buttonsOverlay?.classList.remove('product__buttons--overlay');
  }

  function toggleTab(target) {
    const currentDescription = target.closest('.product__tabsInner').querySelector('.product__tabsDescription');
    const stickyWrapper = document.querySelector('.product__wrapper--sticky');

    target.classList.toggle('product__tabsTitle--active');

    if (target.classList.contains('product__tabsTitle--active')) {
      currentDescription.classList.add('product__tabsDescription--active');
      currentDescription.style.height = `${currentDescription.scrollHeight + 20}px`;
    } else {
      currentDescription.classList.remove('product__tabsDescription--active');
      currentDescription.style.height = `0px`;
    }

    if (document.querySelector('.product__tabsDescription--active')) {
      stickyWrapper.classList.add('product__wrapper--stickyPadding');
    } else {
      stickyWrapper.classList.remove('product__wrapper--stickyPadding');
    }
  }

  function openDropdown() {
    dropdownTitle.click();
  }

  function checkAvailableVariant() {
    const buttonsWrapper = document.querySelector('.product__buttons');
    const addToCartButton = document.querySelector('.add-to-cart');

    if (+addToCartButton.dataset.inventoryQuantity === 0) {
      addToCartButton.disabled = true;
      addToCartButton.classList.add('disabled');
      buttonsWrapper.classList.add('product__buttons--disabled');
      addToCartButton.querySelector('span').innerText = 'SOLD OUT';
      preorderMessage?.classList.remove('hidden');
    }
  }

  addEventListener("resize", () => {
    galleryHeight = document.querySelector('.product__gallery').scrollHeight;
    document.documentElement.style.setProperty('--gallery-height', `${galleryHeight}px`);
  });

  tabTitles.forEach((tab) => {
    tab.addEventListener('click', (e) => {
      toggleTab(e.currentTarget);
    });
  });

  dropdownTitle.addEventListener('click', (e) => {
    toggleDropdown(e.currentTarget);
  });

  dropdownItems.forEach((title) => {
    title.addEventListener('click', (e) => {
      changeButtonData(e.currentTarget);
      toggleDropdownItem(e.currentTarget);
    });
  });

  pageWrapper.addEventListener('click', () => {
    if (!event.target.closest('.product__dropdown')) {
      dropdownList.classList.remove('product__dropdownList--active');
    }
  });

  buttonsOverlay?.addEventListener('click', openDropdown);
  checkAvailableVariant();
})();
